

<section class="d-none"  #PropelldPdfTemplate>
    <a><img src="assets/img/logo.png" alt="Logo" class="headerlogo"/></a>
    <div class="pdf-container">
        <div>
            <p>This is a system generated PDF. Mentioned below are the details of the user order, please attach this
                file to your {{PropelldData?.emiName}} application.
            </p>
        </div>
        <div class="mt-5">
            <p>Application Generate Date-Time: {{dateTime}}</p>
        </div>
        <div class="mt-5">
            <div>
                <p *ngIf="PropelldData?.appFullName">Applicant Full Name: {{PropelldData?.appFullName}}</p>
                <p>Applicant Phone Number: {{PropelldData?.appPhone}}</p>
                <p>Applicant Email Address: <a style="text-decoration: underline;" href="mailto:{{PropelldData?.appEmailId}}">{{PropelldData?.appEmailId}}</a>  </p>
                <p *ngIf="PropelldData?.tenure">Loan Tenure: {{PropelldData?.tenure}}</p>
                <p>Student Full Name: {{PropelldData?.studentName}}</p>
                <p>Student UID: {{PropelldData?.studentId}}</p>
                <p>Student Grade: {{PropelldData?.studentGrade}}</p>
            </div>
            <div *ngFor="let pack of PropelldData?.packages;let i = index">
                <p>Package {{i + 1}} Name: {{pack?.name}}</p>
                <p>Package {{i + 1}} Duration: {{pack?.ducation}}</p>
                <p>Course ID: {{pack?.courseId != null?pack?.courseId:"null"}}</p>
                <p>Batch ID: {{pack?.batchId != null?pack?.batchId:"null"}}</p>
            </div>
            <div>
                <p>Total Order Amount: {{PropelldData?.totalOrderAmount | number : '1.2-2'}}</p>
                <p>Coupon Code Applied: {{PropelldData?.couponCode}} {{PropelldData?.discountType}}</p>
                <p><strong>Amount After Discount: {{PropelldData?.amountAfterDiscount | number : '1.2-2'}}</strong></p>
                <p><strong>Loan Amount:  {{PropelldData?.loanAmount | number : '1.2-2'}}</strong></p>
            </div>
        </div>
    </div>
</section>
